import script from "./UserAvatar.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/user-profile-page/UserAvatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cfe5e996"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cfe5e996', __exports__)) {
    api.reload('cfe5e996', __exports__)
  }
  
}


export default __exports__